import { render, staticRenderFns } from "./PcParticipantApp.vue?vue&type=template&id=a8343ea0"
import script from "./PcParticipantApp.vue?vue&type=script&lang=js"
export * from "./PcParticipantApp.vue?vue&type=script&lang=js"
import style0 from "./PcParticipantApp.vue?vue&type=style&index=0&id=a8343ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
